module.exports = __webpack_public_path__ + "static/media/K.0f8dd073.svg";